import styles from "./AllProducts.module.css";
import commonStyles from "./../../Common.module.css";
import React, { useState, useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import axios from 'axios';

import ProductItem from "./ProductItem";

const kindTitles = {
  all: "",
  dog: "강아지",
  cat: "고양이"
};

const categoryTitles = {
  all: "전체상품",
  feed: "사료",
  snackNutrient: "간식/영양제",
  hygiene: "위생용품",
  beautyCare: "미용/케어용품",
  living: "리빙용품",
  walkPlay: "산책/놀이용품",
  clothesAccessorie: "의류/악세사리"
};

function AllProducts({ calcProductPrice, sortProducts, addCart, setCartItems }) {
  const { kind, category } = useParams();
  const [productData, setProductData] = useState([]);

  const fetchData = () => {
    axios.get(`https://port-0-petmilyreal-1272llwrbm1kq.sel5.cloudtype.app/api/rsproduct/productList/${kind}/${category}`).
    then((response) => {
      setProductData(response.data);
    }).
    catch((err) => {
      alert("상품목록 불러오기에 실패했습니다.");
    });
  };

  useEffect(() => {
    fetchData();
    setCurrentPage(1);
    handleSort("newest");
  }, [kind, category]);

  // 페이지네이션
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // 정렬
  const [sortOption, setSortOption] = useState("default");

  const handleSort = (option) => {
    setSortOption(option);
    setCurrentPage(1); // 페이지를 처음으로 리셋
  };

  const currentItems = sortProducts(productData, sortOption).slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className={styles["Products"]}>
            <div className={commonStyles["cateTitle"]}>
                <h1>{kindTitles[kind] || ""} {categoryTitles[category] || ""}</h1>
            </div>

            <hr />
            <div className={styles["productClassification"]}>
                <ul>
                    <li><NavLink to={`/products/all/${category}`}>전체</NavLink></li>
                    <li><NavLink to={`/products/dog/${category}`}>강아지</NavLink></li>
                    <li><NavLink to={`/products/cat/${category}`}>고양이</NavLink></li>
                </ul>
                <ul>
                    <li><NavLink to={`/products/${kind}/all`}>전체상품</NavLink></li>
                    <li><NavLink to={`/products/${kind}/feed`}>사료</NavLink></li>
                    <li><NavLink to={`/products/${kind}/snackNutrient`}>간식/영양제</NavLink></li>
                    <li><NavLink to={`/products/${kind}/hygiene`}>위생</NavLink></li>
                    <li><NavLink to={`/products/${kind}/beautyCare`}>미용/케어</NavLink></li>
                    <li><NavLink to={`/products/${kind}/living`}>리빙</NavLink></li>
                    <li><NavLink to={`/products/${kind}/walkPlay`}>산책/놀이</NavLink></li>
                    <li><NavLink to={`/products/${kind}/clothesAccessorie`}>의류/악세사리</NavLink></li>
                </ul>
            </div>

            <div className={styles["sortButtons"]}>
                <button className={sortOption === "newest" ? styles["active"] : ""} onClick={() => handleSort("newest")}>최신 등록일순</button>
                <button className={sortOption === "highToLow" ? styles["active"] : ""} onClick={() => handleSort("highToLow")}>가격 높은순</button>
                <button className={sortOption === "lowToHigh" ? styles["active"] : ""} onClick={() => handleSort("lowToHigh")}>가격 낮은순</button>
                <button className={sortOption === "HighAvgStar" ? styles["active"] : ""} onClick={() => handleSort("HighAvgStar")}>평점 높은순</button>
                <button className={sortOption === "HighCntReview" ? styles["active"] : ""} onClick={() => handleSort("HighCntReview")}>리뷰 많은순</button>
            </div>

            <div className={styles["productList"]}>
                {currentItems.map((item) =>
        <ProductItem key={item.product_id} it={item} calcProductPrice={calcProductPrice} addCart={addCart} setCartItems={setCartItems} />
        )}
            </div>

            {/* 페이지네이션 컴포넌트 */}
            <div className={styles["pagination"]}>
                {currentPage > 1 &&
        <a className={styles["first-page"]} onClick={() => paginate(1)}>
                        처음 페이지
                    </a>}
        

                {Array.from({ length: Math.ceil(productData.length / itemsPerPage) }).map((_, index) =>
        <a
          key={index}
          onClick={() => paginate(index + 1)}
          className={index + 1 === currentPage ? styles["active"] : ""}>
          
                        {index + 1}
                    </a>
        )}

                {currentPage < Math.ceil(productData.length / itemsPerPage) &&
        <a className={styles["last-page"]} onClick={() => paginate(Math.ceil(productData.length / itemsPerPage))}>
                        마지막 페이지
                    </a>}
        
            </div>
        </div>);

}

export default AllProducts;